// Copyright 2015-2023 Nstream, inc.
// All rights reserved.

import {Lazy} from "@swim/util";
import type {Class} from "@swim/util";
import {Property} from "@swim/component";
import type {Uri} from "@swim/uri";
import type {Value} from "@swim/structure";
import {Model} from "@swim/model";
import {TraitModelRef} from "@swim/model";
import type {Graphics} from "@swim/graphics";
import {PolygonIcon} from "@swim/graphics";
import type {EntityTraitObserver} from "@nstream/domain";
import {EntityTrait} from "@nstream/domain";
import {LaneAspectTrait} from "./LaneAspectTrait";

/** @public */
export interface LanesEntityTraitObserver<T extends LanesEntityTrait = LanesEntityTrait> extends EntityTraitObserver<T> {
}

/** @public */
export class LanesEntityTrait extends EntityTrait {
  readonly laneType: Value;

  constructor(laneType: Value) {
    super();
    this.icon.setIntrinsic(LanesEntityTrait.icon);
    this.relatable.setIntrinsic(false);
    this.searchable.set(true);
    this.laneType = laneType;
  }

  declare readonly observerType?: Class<LanesEntityTraitObserver>;

  @Property({
    extends: true,
    inherits: true, // inherit nodeUri from parent entity
  })
  override get nodeUri(): Property<this, Uri | null> {
    return Property.getter();
  }

  @TraitModelRef({
    modelType: Model,
    modelKey: "portal",
    traitType: LaneAspectTrait,
    traitKey: "aspect",
  })
  readonly portal!: TraitModelRef<this, LaneAspectTrait>;

  @Lazy
  static get icon(): Graphics {
    return PolygonIcon.create(3);
  }
}
